module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cookie-warning"
    }
  }, [_c('div', {
    staticClass: "cookie-text"
  }, [_c('p', [_vm._v("Za boljše delovanje ta stran uporablja piškotke. Dovolite uporabo piškotkov? "), _c('router-link', {
    attrs: {
      "to": "/cookies/"
    }
  }, [_vm._v("Več o piškotkih")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised allow",
    on: {
      "click": _vm.allowCookies
    }
  }, [_vm._v("Dovolim")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised forbid",
    on: {
      "click": _vm.forbidCookies
    }
  }, [_vm._v("Ne Dovolim")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aafb8092","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cookieWarning.vue
// module id = 72
// module chunks = 0